<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->

<div #areaChartContainer class="h-30 flex items-center">
  <div *ngIf="!series" class="text-xs-11 text-center">
    {{ projectCardConstants.areaChartError }}
  </div>
</div>
